import { API_BASE_URL } from '@/config';
import { apiService } from '../../utils/api';

export interface Device {
  id: number;
  device_id: string;
  account: string;
  last_message_time: string;
  created_at: string;
  updated_at: string;
}

// Updated to match the actual data structure returned by the API
export interface DeviceListData {
  devices: Device[];
  pagination: {
    page: number;
    pageSize: number;
    total: number;
    totalPage: number;
  }
}

export interface DeviceListParams {
  page: number;
  pageSize: number;
  search?: string;
}

// Function to fetch devices with pagination and search
export const fetchDevices = async (params: DeviceListParams): Promise<DeviceListData> => {
  try {
    const queryParams = new URLSearchParams();
    queryParams.append('page', params.page.toString());
    queryParams.append('pageSize', params.pageSize.toString());
    
    if (params.search) {
      queryParams.append('search', params.search);
    }
    
    // Using apiService - it now directly returns the data part
    return await apiService.get<DeviceListData>(`/api/v1/admin/devices?${queryParams.toString()}`);
  } catch (error) {
    console.error('Failed to fetch devices:', error);
    throw error;
  }
};

// Function to fetch a single device by its ID
// Uses the /api/v1/device/:deviceID endpoint from router.go
export const fetchDeviceById = async (deviceId: string): Promise<Device> => {
  try {
    return await apiService.get<Device>(`/api/v1/device/${deviceId}`);
  } catch (error) {
    console.error(`Failed to fetch device with ID ${deviceId}:`, error);
    throw error;
  }
};